"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargeJobBillingHelper = void 0;
const JobBillingHelper_1 = require("./JobBillingHelper");
class ChargeJobBillingHelper extends JobBillingHelper_1.JobBillingHelper {
    constructor(job) {
        function changeKey(key) {
            return key.replace(/^charge_/, '');
        }
        const jobFormatted = Object.assign({}, ...Object.keys(job).
            map((key) => ({ [changeKey(key)]: job[key] })));
        const jobBillingFormatted = Object.assign({}, ...Object.keys(job.job_billing_sums).
            map((key) => ({ [changeKey(key)]: job.job_billing_sums[key] })));
        super({
            ...jobFormatted,
            job_billing_sums: jobBillingFormatted
        });
    }
}
exports.ChargeJobBillingHelper = ChargeJobBillingHelper;
